if(!customElements.get('benefits-slider')) {
  customElements.define(
    'benefits-slider',
    class BenefitsSlider extends HTMLElement {
      sliderEl = undefined;
      sliderPaginationEl = undefined;
      sliderInstance = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('.slider');
        this.sliderPaginationEl = this.querySelector('.benefits-slider-pagination');
        this.mount();
      }

      mount() {
        if(!this.sliderEl) {
          return console.error("[Benefits Section] No slider element found!")
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 36,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 36,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 48
            }
          },
          pagination: {
            el: this.sliderPaginationEl,
            type: "bullets",
            clickable: true
          }
        });
      }

      get slider() {
        return this.sliderInstance;
      }
    }
  )
}


